module.exports = __webpack_public_path__ + "img/cash_out.271f96b5.svg";